import { Question } from './question';
import { Proposition } from './proposition';

export class QuestionChoixMultiple extends Question {
  propositions: Proposition[] = [];
}
